import React from 'react';

interface VideoIframeProps {
  videoId: string; // just the YouTube ID (e.g. "dQw4w9WgXcQ")
  title?: string;
  className?: string;
  allowFullScreen?: boolean;
}

export default function VideoIframe({
  videoId,
  title = 'YouTube video player',
  className,
  allowFullScreen = true,
}: VideoIframeProps) {
  const src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}`;

  return (
    <iframe
      className={className}
      src={src}
      title={title}
      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
      {...(allowFullScreen ? { allowFullScreen: true } : {})}
    />
  );
}
